import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';

const TickAddonContainer = styled.div<React.CSSProperties>`
  left: ${300 * Screen.widthRatio}px;
  position: relative;
  top: ${-182 * Screen.widthRatio}px;
  width: fit-content;
`;

export default TickAddonContainer;
